module.exports = __webpack_public_path__ + "static/media/nexterThumbnail.a9e1d45c.png";